import React, { Component } from 'react';
import Hamburger from './Hamburger';
import style from './Header.module.scss';
import Logo from './Logo';
import MainNav from './MainNav';

class Header extends Component {
  state = {
    isVisible: true,
    isDropdownNavOpen: false,
    isSocialExpanded: false,
  };

  animateIn = () => {
    TweenLite.to(this.headerEl, 0.75, {
      autoAlpha: 1,
      y: 0,
      ease: Quad.easeInOut,
    });
  };

  componentDidMount() {
    TweenLite.set(this.headerEl, {
      autoAlpha: 0,
      y: 20,
    });
    if (!this.props.introIsShowing) {
      this.animateIn();
    }
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.introIsShowing !== prevProps.introIsShowing &&
      !this.props.introIsShowing
    ) {
      this.animateIn();
    }
  }

  handleDropdownChange = () => {
    this.setState(state => ({
      isDropdownNavOpen: !state.isDropdownNavOpen,
    }));
  };

  handleHeaderClass = () => {
    let headerClass = '';
    if (this.props.headerHasGradient) {
      headerClass += ` ${style.headerGradient}`;
    }
    if (!this.props.headerIsTransparent) {
      headerClass += ` ${style.headerBackground}`;
    }
    if (this.props.headerIsSticky) {
      headerClass += ` ${style.headerSticky}`;
      if (this.props.location.pathname.indexOf('walking') !== -1) {
        headerClass += ` ${style.removeGradient}`;
      }
    }
    if (this.props.headerIsStatic) {
      headerClass += ` ${style.headerStatic}`;
    }
    return headerClass;
  };

  toggleSocial = value => {
    if (value) {
      this.setState({
        isSocialExpanded: value,
      });
    } else {
      this.setState(state => ({
        isSocialExpanded: !state.isSocialExpanded,
      }));
    }
  };

  render() {
    return (
      <header
        className={`${this.handleHeaderClass()} site-header`}
        ref={el => {
          this.headerEl = el;
        }}
      >
        <Logo
          introIsShowing={this.props.introIsShowing}
          logoColor={this.props.logoColor}
        />
        <MainNav
          introIsShowing={this.props.introIsShowing}
          chapterData={this.props.chapterData}
          timelineData={this.props.timelineData}
          dropdownNavColor={this.props.dropdownNavColor}
          exhibitionData={this.props.exhibitionData}
          handleDropdownChange={this.handleDropdownChange}
          handleSocialExpanded={this.toggleSocial}
          isSocialExpanded={this.state.isSocialExpanded}
          isMobileMenuOpen={this.props.isMobileMenuOpen}
          menuCollapsedPage={this.props.menuCollapsedPage}
          menuToggledOpen={this.props.menuToggledOpen}
          isSocialExpanded={this.state.isSocialExpanded}
          isMenuCollapsed={
            this.props.menuCollapsedPage && !this.props.menuToggledOpen
          }
          registerEraSkip={this.props.registerEraSkip}
          isDropdownNavOpen={this.state.isDropdownNavOpen}
          location={this.props.location}
          mainNavColor={this.props.mainNavColor}
          settingsContent={this.props.settingsContent}
          handleChapterNav={this.props.handleChapterNav}
        />
        <Hamburger
          isMenuCollapsed={
            this.props.menuCollapsedPage && !this.props.menuToggledOpen
          }
          menuCollapsedPage={this.props.menuCollapsedPage}
          menuToggledOpen={this.props.menuToggledOpen}
          toggleDesktopMenu={this.props.toggleDesktopMenu}
          handleMobileMenu={this.props.handleMobileMenu}
          isMobileMenuOpen={this.props.isMobileMenuOpen}
          mainNavColor={this.props.mainNavColor}
          onMenuChange={this.handleMenuChange}
        />
        {this.state.isDropdownNavOpen && (
          <div
            className={style.clickCatch}
            onClick={this.handleDropdownChange}
          />
        )}
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/global/Header.js